import { create } from 'zustand';

const useStore = create((set) => ({
    // ----- USER SIGNIN STATE ----- //
    userAuthDetail: { userInfo: null, loading: false },
    signinRequest: () => set({ userAuthDetail: { userInfo: null, loading: true } }),
    signinSuccess: (userData) => set({ userAuthDetail: { userInfo: userData, loading: false } }),
    signOut: () => set({ userAuthDetail: { userInfo: null, loading: false } }),
    otpValidationError:false,
    setOtpValidationError: (error) => set({ otpValidationError: error }),

    showBecomeMemberPopup:false,
    setShowBecomeMemberPopup: (data) => set({ showBecomeMemberPopup: data }),

    isOpenCandidatesDeservingModel:false,
    setIsOpenCandidatesDeservingModel: (data) => set({ isOpenCandidatesDeservingModel: data }),

    deservingCandidatesProfileData:{},
    setDeservingCandidatesProfileData: (data) => set({ deservingCandidatesProfileData: data }),

    // ----- USER SESSION STATE ----- //
    userSession: { loading: true, success: 0 },
    startUserSession: () => set({ userSession: { loading: true, success: 0 } }),
    setUserSession: (data) => set({ userSession: { loading: false, success: data } }),

    isDetailOpen: false,
    setIsDetailOpen: (data) => set({ isDetailOpen: data }),

    openEditUserDetail: false,
    setOpenEditUserDetail: (data) => set({ openEditUserDetail: data }),


    isJobDetailOpen: false,
    setIsJobDetailOpen: (data) => set({ isJobDetailOpen: data }),

    isAssignmentDetailOpen: false,
    setIsAssignmentDetailOpen: (data) => set({ isAssignmentDetailOpen: data }),

    isMatrimonialDetailOpen: false,
    setIsMatrimonialDetailOpen: (data) => set({ isMatrimonialDetailOpen: data }),

    isEventDetailOpen: false,
    setIsEventDetailOpen: (data) => set({ isEventDetailOpen: data }),

    notificationSheetOpen: false,
    setNotificationSheetOpen: (data) => set({ notificationSheetOpen: data }),

    menuOpen: false,
    setMenuOpen: (data) => set({ menuOpen: data }),

    // ----- USER SESSION STATE ----- //
    currentMemberMemberShipDetail: { loading: true, memberShipDetail: {} },
    getCurrentMemberMemberShipDetailRequest: () => set({ currentMemberMemberShipDetail: { loading: true, memberShipDetail: {} } }),
    getCurrentMemberMemberShipDetailSuccess: (data) => set({ currentMemberMemberShipDetail: { loading: false, memberShipDetail: data } }),

    // ----- SIGNUP/SIGNIN FORM ERROR ----- //
    signupSigninError: null,
    setSignupSigninError: (error) => set({ signupSigninError: error }),

    // ----- OTP ----- //
    userOtpDetails: { loading: false, success: false, error: null },
    getOtpRequest: () => set({ userOtpDetails: { loading: true, success: false, error: null } }),
    getOtpSuccess: () => set({ userOtpDetails: { loading: false, success: true, error: null } }),
    getOtpFail: () => set({ userOtpDetails: { loading: false, success: false, error:'Wrong OTP!!' } }),

    // ----- selected news category ----- //
    selectedNewsCategory: '',
    setSelectedNewsCategory: (category) => set({ selectedNewsCategory: category }),

    // ----- CATEGORY NEWS DATA ----- //
    newsCategory: { loading: true, categoryData: [] },
    requestNewsCategory: () => set({ newsCategory: { loading: true, categoryData: [] } }),
    setNewsCategoryData: (data) => set({ newsCategory: { loading: false, categoryData: data } }),

    // ----- USER SESSION STATE ----- //
    newsDetailDataList: { loading: true, newsDetailList: [],offset:0 },
    setNewsDetailDataListLoading: () => set({ newsDetailDataList: { loading: true, newsDetailList: [],offset:0 } }),
    setNewsDetailDataListSuccess: (data) => set({ newsDetailDataList: { loading: false, newsDetailList: data?.newsDetailList,offset:data?.offset } }),

    bookmarkedNewsDetailDataList: { loading: true, bookmarkedNewsDetailDataList: [],offset:0 },
    setBookmarkedNewsDetailDataListLoading: () => set({ bookmarkedNewsDetailDataList: { loading: true, newsDetailList: [],offset:0 } }),
    setBookmarkedNewsDetailDataListSuccess: (data) => set({ bookmarkedNewsDetailDataList: { loading: false, newsDetailList: data?.newsDetailList,offset:data?.offset } }),

    newsDetailsData: {},
    setNewsDetailsData: (data) => set({ newsDetailsData: data }),

    updateBookmarkStatus: (newsId, newStatus) =>
        set((state) => {
            const updatedList = state.newsDetailsDataList?.newsDetailList?.map((item) =>
                item.id === newsId ? { ...item, is_bookmarked: newStatus } : item
            ) || [];

            const updatedDetails =
                state.newsDetailsData?.id === newsId
                    ? { ...(state.newsDetailsData ?? {}), is_bookmarked: newStatus }
                    : state.newsDetailsData;

            return {
                newsDetailsDataList: {
                    ...(state.newsDetailsDataList ?? []),
                    newsDetailList: updatedList,
                },
                newsDetailsData: updatedDetails,
            };
        }),


    jobAppliedMemberDataList: [],
    setJobAppliedMemberDataList: (data) => set({ jobAppliedMemberDataList:data }),

    // ----- JOB POSTING STATE ----- //
    jobPostingState: {
        loading: true,
        jobPostings: [],
        offset: 0,
        totalCount: 0,
    },

    setJobPostingLoading: () =>
        set({
            jobPostingState: {
                loading: true,
                jobPostings: [],
                offset: 0,
                totalCount: 0
            }
        }),

    setJobPostingSuccess: (data) =>
        set({
            jobPostingState: {
                loading: false,
                jobPostings: data?.jobPostings || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
            }
        }),

    setJobPostingFail: (error) =>
        set((state) => ({
            jobPostingState: {
                ...(state.jobPostingState ?? []),
                loading: false,
                error
            }
        })),
    // ----- JOB POSTING STATE ----- //

    // ----- JOB FILTER STATE ----- //
    selectedWorkTypes: [],
    selectedDepartments: [],
    selectedIsMyJobProfile: false,
    selectedState: [],
    experience: 0,
    salaryRange: 0,

    setSelectedWorkTypes: (data) => set({ selectedWorkTypes: data }),
    setSelectedIsMyJobProfile: (data) => set({ selectedIsMyJobProfile: data }),
    setSelectedDepartments: (data) => set({ selectedDepartments: data }),
    setSelectedState: (data) => set({ selectedState: data }),
    setExperience: (val) => set({ experience: val }),
    setSalaryRange: (val) => set({ salaryRange: val }),

    resetFilters: () => set({
        selectedWorkTypes: [],
        selectedDepartments: [],
        selectedState: [],
        experience: 0,
        salaryRange: 0,
    }),
    // ----- JOB FILTER STATE ----- //


    // ----- MATRIMONIAL POSTING STATE ----- //
    matrimonialPostingState: {
        loading: true,
        profiles: [],
        offset: 0,
        totalCount: 0,
    },

    setMatrimonialPostingLoading: () =>
        set({
            matrimonialPostingState: {
                loading: true,
                profiles: [],
                offset: 0,
                totalCount: 0,
            },
        }),

    setMatrimonialPostingSuccess: (data) =>
        set({
            matrimonialPostingState: {
                loading: false,
                profiles: data?.profiles || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
            },
        }),

    setMatrimonialPostingFail: (error) =>
        set((state) => ({
            matrimonialPostingState: {
                ...(state.matrimonialPostingState ?? []),
                loading: false,
                error,
            },
        })),
    // ----- MATRIMONIAL POSTING STATE ----- //

    // ----- MATRIMONIAL FILTER STATE ----- //
    selectedReligion: [],
    selectedAge: 0,
    selectedIsMyProfile: false,
    selectedEducation: '',
    selectedLocation: [],
    selectedMeritialStatus: [],
    selectedHeight: 0,
    selectedManglikStatus: '',

    setSelectedReligion: (data) => set({ selectedReligion: data }),
    setSelectedIsMyProfile: (data) => set({ selectedIsMyProfile: data }),
    setSelectedAge: (age) => set({ selectedAge: age }),
    setSelectedEducation: (edu) => set({ selectedEducation: edu }),
    setSelectedLocation: (data) => set({ selectedLocation: data }),
    setSelectedMeritialStatus: (data) => set({ selectedMeritialStatus: data }),
    setSelectedHeight: (height) => set({ selectedHeight: height }),
    setSelectedManglikStatus: (status) => set({ selectedManglikStatus: status }),

    resetMatrimonialFilters: () =>
        set({
            selectedReligion: [],
            selectedAge: 0,
            selectedEducation: '',
            selectedLocation: [],
            selectedMeritialStatus: [],
            selectedHeight: 0,
            selectedManglikStatus: '',
            selectedIsMyProfile: false,
        }),
    // ----- MATRIMONIAL FILTER STATE ----- //

    // ----- RFP ASSIGNMENT STATE ----- //
    rfpAssignmentDataState: {
        loading: true,
        assignments: [],
        offset: 0,
        totalCount: 0,
    },

    setRfpAssignmentLoading: () =>
        set({
            rfpAssignmentDataState: {
                loading: true,
                assignments: [],
                offset: 0,
                totalCount: 0,
            },
        }),

    setRfpAssignmentSuccess: (data) =>
        set({
            rfpAssignmentDataState: {
                loading: false,
                assignments: data?.assignments || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
            },
        }),

    setRfpAssignmentFail: (error) =>
        set((state) => ({
            rfpAssignmentDataState: {
                ...(state.rfpAssignmentDataState ?? []),
                loading: false,
                error,
            },
        })),

    selectedRetainership: '',
    selectedExpiryDate: 0,
    selectedPrice: '',
    selectedAssignmentLocation: [],
    selectedAssignmentMeMode: false,

    setSelectedAssignmentMeMode: (data) => set({ selectedAssignmentMeMode: data }),
    setSelectedRetainership: (data) => set({ selectedRetainership: data }),
    setSelectedExpiryDate: (data) => set({ selectedExpiryDate: data }),
    setSelectedPrice: (data) => set({ selectedPrice: data }),
    setSelectedAssignmentLocation: (data) => set({ selectedAssignmentLocation: data }),


    resetAssignmentFilters: () =>
        set({
            selectedRetainership: '',
            selectedExpiryDate: 0,
            selectedPrice: '',
            selectedAssignmentMeMode: false,
            selectedAssignmentLocation: []
        }),
// ----- RFP ASSIGNMENT STATE ----- //



    // ----- NEWS LETTER STATE ----- //
    newsLettersDataState: {
        loading: true,
        newsLettersData: [],
        offset: 0,
        totalCount: 0,
        error: null,
    },

    setNewsLettersLoading: () =>
        set({
            newsLettersDataState: {
                loading: true,
                newsLettersData: [],
                offset: 0,
                error: null,
            },
        }),

    setNewsLettersSuccess: (data) =>
        set({
            newsLettersDataState: {
                loading: false,
                newsLettersData: data?.newsLettersData || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setNewsLettersFail: (error) =>
        set((state) => ({
            newsLettersDataState: {
                ...(state.newsLettersDataState ?? []),
                loading: false,
                error,
            },
        })),

    selectedNewsLetterDateFilter: new Date().getFullYear(),

    setSelectedNewsLetterDateFilter: (date) =>
        set({ selectedNewsLetterDateFilter: date }),

    resetNewsLetterFilters: () =>
        set({
            selectedNewsLetterDateFilter: new Date().getFullYear(),
        }),


    // ----- EVENT STATE ----- //
    eventsDataState: {
        loading: true,
        eventsData: [],
        offset: 0,
        totalCount: 0,
        error: null,
    },

    setEventsLoading: () =>
        set({
            eventsDataState: {
                loading: true,
                eventsData: [],
                offset: 0,
                error: null,
            },
        }),

    setEventsSuccess: (data) =>
        set({
            eventsDataState: {
                loading: false,
                eventsData: data?.eventsData || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setEventsFail: (error) =>
        set((state) => ({
            eventsDataState: {
                ...(state.eventsDataState ?? []),
                loading: false,
                error,
            },
        })),

    selectedEventIsPastFilter: false,

    setSelectedEventIsPastFilter: (date) =>
        set({ selectedEventIsPastFilter: date }),

    resetEventFilters: () =>
        set({
            selectedEventIsPastFilter: false,
        }),



    // ----- NEWS STATE ----- //
    newsDataState: {
        loading: true,
        newsData: [],
        offset: 0,
        totalCount: 0,
        error: null,
    },

    setNewsLoading: () =>
        set({
            newsDataState: {
                loading: true,
                newsData: [],
                offset: 0,
                totalCount: 0,
                error: null,
            },
        }),

    setNewsSuccess: (data) =>
        set({
            newsDataState: {
                loading: false,
                newsData: data?.newsData || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setNewsFail: (error) =>
        set((state) => ({
            newsDataState: {
                ...(state.newsDataState ?? []),
                loading: false,
                error,
            },
        })),


    // ----- CONTRIBUTION STATE ----- //
    contributionDataState: {
        loading: true,
        contributions: [],
        offset: 0,
        totalCount: 0,
        error: null,
    },

    setContributionLoading: () =>
        set({
            contributionDataState: {
                loading: true,
                contributions: [],
                offset: 0,
                totalCount: 0,
                error: null,
            },
        }),

    setContributionSuccess: (data) =>
        set({
            contributionDataState: {
                loading: false,
                contributions: data?.contributions || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setContributionFail: (error) =>
        set((state) => ({
            contributionDataState: {
                ...(state.contributionDataState ?? []),
                loading: false,
                error,
            },
        })),

    userContributionDataState: {
        loading: true,
        contributions: [],
        allContributions: [],
        offset: 0,
        totalCount: 0,
        error: null,
    },
    setUserContributionLoading :() =>
        set({
            userContributionDataState:{
                loading: true,
                contributions: [],
                allContributions: [],
                offset: 0,
                totalCount: 0,
                error: null,
            },
        }),

    setUserContributionSuccess: (data) =>
        set({
            userContributionDataState: {
                loading: false,
                contributions: data?.contributions || [],
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                allContributions: data?.allContributions || [],
                error: null,
            },
        }),

    setUserContributionFail: (error) =>
        set((state) => ({
            userContributionDataState: {
                ...(state.contributionDataState ?? []),
                loading: false,
                error,
            },
        })),


    // ----- MEMBERSHIP STATE ----- //
    memberShipDataState: {
        loading: true,
        memberships: [],   // list of membership transactions
        offset: 0,         // for pagination
        totalCount: 0,     // total records count
        error: null,
    },

    setMemberShipLoading: () =>
        set({
            memberShipDataState: {
                loading: true,
                memberships: [],
                offset: 0,
                totalCount: 0,
                error: null,
            },
        }),

    setMemberShipSuccess: (data) =>
        set({
            memberShipDataState: {
                loading: false,
                memberships: data?.memberships || [],  // expects array of rows
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setMemberShipFail: (error) =>
        set((state) => ({
            memberShipDataState: {
                ...(state.memberShipDataState ?? []),
                loading: false,
                error,
            },
        })),



    // ----- USER MANAGEMENT STATE ----- //
    usersDataState: {
        loading: true,
        usersData: [],       // list of users
        offset: 0,       // for pagination
        totalCount: 0,   // total number of users
        error: null,
    },

    setUsersLoading: () =>
        set({
            usersDataState: {
                loading: true,
                usersData: [],
                offset: 0,
                totalCount: 0,
                error: null,
            },
        }),

    setUsersSuccess: (data) =>
        set({
            usersDataState: {
                loading: false,
                usersData: data?.usersData || [],       // expects array of user rows
                offset: data?.offset || 0,
                totalCount: data?.totalCount || 0,
                error: null,
            },
        }),

    setUsersFail: (error) =>
        set((state) => ({
            usersDataState: {
                ...(state.usersDataState ?? []),
                loading: false,
                error,
            },
        })),

    // ----- NOTIFICATION STATE ----- //
    notificationsDataState: {
        loading: true,
        notifications: [],   // list of notifications
        totalCount: 0,       // unseen/total notifications
        error: null,
    },

    setNotificationsLoading: () =>
        set({
            notificationsDataState: {
                loading: true,
                notifications: [],
                totalCount: 0,
                error: null,
            },
        }),

    setNotificationsSuccess: (data) =>
        set({
            notificationsDataState: {
                loading: false,
                notifications: data?.notifications || [],   // expects array of notifications
                totalCount: data?.totalCount || 0,          // backend should return count
                error: null,
            },
        }),

    setNotificationsFail: (error) =>
        set((state) => ({
            notificationsDataState: {
                ...(state.notificationsDataState ?? []),
                loading: false,
                error,
            },
        })),


    userJobProfileData: { loading: true, jobProfileData: {} },
    requestUserJobProfileData: () => set({ userJobProfileData: { loading: true, jobProfileData: {} } }),
    setUserJobProfileData: (data) => set({ userJobProfileData: { loading: false, jobProfileData: data } }),


    userJobPostData: { loading: true, jobPostData: [] },
    requestUserJobPostData: () => set({ userJobPostData: { loading: true, jobPostData: [] } }),
    setUserJobPostData: (data) => set({ userJobPostData: { loading: false, jobPostData: data } }),

    otherUsersJobPostData: { loading: true, jobPostData: [] },
    requestOtherUsersJobPostData: () => set({ otherUsersJobPostData: { loading: true, jobPostData: [] } }),
    setOtherUsersJobPostData: (data) => set({ otherUsersJobPostData: { loading: false, jobPostData: data } }),


    otherUsersJobProfileData: { loading: true, jobProfileData: [] },
    requestOtherUsersJobProfileData: () => set({ otherUsersJobProfileData: { loading: true, jobProfileData: [] } }),
    setOtherUsersJobProfileData: (data) => set({ otherUsersJobProfileData: { loading: false, jobProfileData: data } }),

    jobDetailsData:{},
    setJobDetailsData: (data) => set({ jobDetailsData: data }),

    assignmentDetail:{},
    setAssignmentDetail: (data) => set({ assignmentDetail: data }),

    matrimonialProfileDetail:{},
    setMatrimonialProfileDetail: (data) => set({ matrimonialProfileDetail: data }),

    userAssignmentPostData: { loading: true, assignmentPostData: [] },
    requestUserAssignmentPostData: () => set({ userAssignmentPostData: { loading: true, assignmentPostData: [] } }),
    setUserAssignmentPostData: (data) => set({ userAssignmentPostData: { loading: false, assignmentPostData: data } }),

    otherUsersAssignmentPostData: { loading: true, assignmentPostData: [] },
    requestOtherUsersAssignmentPostData: () => set({ otherUsersAssignmentPostData: { loading: true, assignmentPostData: [] } }),
    setOtherUsersAssignmentPostData: (data) => set({ otherUsersAssignmentPostData: { loading: false, assignmentPostData: data } }),


    userMatrimonialProfileData: { loading: true, matrimonialProfileData: [] },
    requestUserMatrimonialProfileData: () => set({ userMatrimonialProfileData: { loading: true, matrimonialProfileData: [] } }),
    setUserMatrimonialProfileData: (data) => set({ userMatrimonialProfileData: { loading: false, matrimonialProfileData: data } }),

    otherUsersMatrimonialProfileData: { loading: true, matrimonialProfileData: [] },
    requestOtherUsersMatrimonialProfileData: () => set({ otherUsersMatrimonialProfileData: { loading: true, matrimonialProfileData: [] } }),
    setOtherUsersMatrimonialProfileData: (data) => set({ otherUsersMatrimonialProfileData: { loading: false, matrimonialProfileData: data } }),

}));

export default useStore;
